import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getAppeals(context) {
      const response = await Vue.axios.get(`${URL_API}appeal/index`);
      let data = response["data"];
      context.commit("updateAppeals", data);
    },
    async getAppealsByPlant(context, plant_id) {
      const response = await Vue.axios.get(
        `${URL_API}appeal/get-by-plant?plant_id=${plant_id}`
      );
      return response["data"];
    },
    async createAppeal(
      context,
      { full_name, email, phone, body, image, plant_id, object_type }
    ) {
      const config = {};
      let formBody = {};
      if (full_name) formBody.full_name = full_name;
      if (email) formBody.email = email;
      if (phone) formBody.phone = phone;
      if (body) formBody.body = body;
      if (image) formBody.image = image;
      if (plant_id) formBody.plant_id = plant_id;
      if (object_type) formBody.object_type = object_type;
      console.log(formBody);

      let formData = new FormData();
      try {
        Object.entries(formBody).forEach(([key, value]) => {
          formData.append(key, value);
        });
        await Vue.axios.post(`${URL_API}appeal/create`, formData, config);
        context.commit("updateMessage", "Заявка отправлена", {
          root: true
        });
      } catch (error) {
        context.commit("updateMessage", "Заявка не создана", {
          root: true
        });
      }
    }
  },
  mutations: {
    updateAppeals(state, data) {
      state.appeals = data;
    },
    updateCount(state) {
      state.counter += 1;
    }
  },
  state: {
    appeals: [],
    counter: 0
  },
  getters: {
    allAppeals(state) {
      return state.appeals;
    }
  }
};
